<template>
  <div class="footer">
    <div class="footerInnerWrapper">
      <div class="contentContainer">
        <div class="logoDiv">
          <img class="logo" alt src="../assets/header_logo.svg" />
        </div>
        <div class="footerTextDiv">
            <span class="col col1">©Copyright 2020 Orium.<br class="brMed"> All Rights Reserved.</span>
            <br class="brMed">
            <a href="https://orium.com/contact" target="_blank" class="col col4">Contact</a>
            <br class="brSml">
            <a href="https://orium.com/privacy-policy" target="_blank" class="col col3">Privacy Policy</a>
            <br class="brSml">
            <a href="https://orium.com/accessibility" target="_blank" class="col col2">Accessiblity Policy</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.footerTextDiv {
  text-align: left;
  line-height: 32px;
}

.contentContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin-top: 90px;
}

.footerInnerWrapper {
  margin-left: 32px;
  margin-right: 32px;
}
.col {
  color: black;
  font-family: "SofiaProRegular";
  margin-right: 32px;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 178px;
  width: 60%;
  margin-bottom: 50px;
}
.footer .logo {
  height: 25px;
  margin-right: 32px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

br {
  display: none;
}

@media only screen and (min-width: 1200px) and (max-width: 1448px) {
  .footer {
    width: 70%;
    margin: 0 auto;
    margin-bottom: 50px;
  }
}

@media only screen and (min-width: 1029px) and (max-width: 1199px) {
  .footer {
    width: 70%;
    margin: 0 auto;
    margin-bottom: 50px;
  }
}

@media only screen and (max-width: 1200px) {
  .logoDiv {
    width: 100%;
    text-align: left;
  }

  .brMed {
    display: block;
  }
}

@media only screen and (min-width: 823px) and (max-width: 1028px) {
  .footer {
    width: 800px;
    margin: 0 auto;
    margin-bottom: 50px;
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  .footer {
    width: 600px;
    margin: 0 auto;
    margin-bottom: 50px;
  }
}
@media only screen and (min-width: 375px) and (max-width: 515px) {
  .footer {
    width: 100%;
  }

  .brSml {
    display: block;
  }
}
</style>
